import { commonFilter } from './filter';

export default {
  pageName: 'channelDetail',
  pageId: '20006',
  pagePath: '/opinion/Stats/Detail',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
